import React from 'react'

import Navbar from '../../components/navbar'
import Blocks from './blocks'
import Mission from './mission'
import Story from './story'

const About = () => {
  return (
    <div className='section about'>
      <Navbar />
      <div className='opener'>
        <div className='background-intro'>
          <i class='bi bi-droplet-half'></i>
        </div>
        <div className='container'>
          <div
            className='head'
            data-aos='fade-up'
            data-aos-delay='100'
            data-aos-duration='500'
          >
            We are Strategists, Engineers, Managers, Investors and Techies
          </div>
          <p data-aos='fade-up' data-aos-delay='500'>
            Rean Watertech is a unique water company which is exclusively
            focused on executing water and wastewater projects globally. Our
            project protfolio is wide and integrated. It starts from design,
            detailed engineering, construction, erection & comissionning all the
            way to operations & maintainance of water assets catering to rural
            and urban population. We are thriving to acquire sizable business in
            the segment.
          </p>
        </div>
      </div>

      <Mission />
      <Blocks />
      <Story />
    </div>
  )
}

export default About
